import { addWindowResizeEvent } from '@theme/utilities';
import { initTableOfContents } from './modules/helper';
import { DOMSTRING } from './modules/init';

const runInitialization = () => {
	document.querySelectorAll(DOMSTRING.tableOfContents).forEach(initTableOfContents);
};

runInitialization();
addWindowResizeEvent(runInitialization);
